// React
import { useContext } from "react"

// Components
import { BaseTable, Loading, TableHeader } from "components"

// Contexts
import { DataContext, DropdownContext } from "../contexts"

// Icons
import { IoSendSharp } from "react-icons/io5"

// Utils
import { convertNumber } from "utils"

export function DetailReject(): JSX.Element {
  // Hooks
  const { product } = useContext(DropdownContext)
  const {
    onAddDetail,
    data: { detailreject }
  } = useContext(DataContext)

  return (
    <BaseTable>
      <TableHeader>
        <tr>
          <th></th>
          <th>QTY REJECTED</th>
          <th>QTY RECEIVED</th>
          <th>BACK DELIVERED</th>
          <th>UNIT</th>
          <th>ITEM CODE</th>
          <th>DESCRIPTION</th>
          <th>PRICE</th>
          <th>DISC (%)</th>
          <th>TOTAL</th>
          <th>TAX</th>
          <th>ACTION</th>
        </tr>
      </TableHeader>

      <tbody>
        {!detailreject.length ? (
          <tr>
            <td colSpan={12}>
              <Loading errorText="No data available" />
            </td>
          </tr>
        ) : detailreject.map((item, key) => {
          // Vars
          const productData = product.find(i => i.product_id === item.product_id)
          const isDisabled: boolean = item.qty_received_item >= item.quantity_reject

          return (
            <tr
              key={key}
              className={`${isDisabled && "text-error line-through"}`}
            >
              <td>
                {!isDisabled && (
                  <button
                    className="-rotate-90"
                    onClick={() => {
                      onAddDetail({
                        discount: item.discount,
                        price_received: item.price_reject,
                        product_id: item.product_id,
                        qty_back_delivered: item.qty_back_delivered,
                        qty_received_item: 0,
                        qty_unit: item.quantity_unit,
                        tax_id: item.tax_id,
                        tax_rate: item.tax_rate,
                        total: 0,
                        total_tax_paid: 0,
                        unit_measure: item.unit_measure
                      })
                    }}
                  >
                    <IoSendSharp />
                  </button>
                )}
              </td>

              <td className="text-right">{item.quantity_reject}</td>
              <td className="text-right">{item.qty_received_item}</td>
              <td className="text-right">{item.qty_back_delivered}</td>
              <td>{item.unit_measure}</td>
              <td className="text-center">{productData?.product_barcode}</td>
              <td>{productData?.product_name}</td>
              <td className="text-right">{convertNumber(item.price_reject).intoCurrency}</td>
              <td className="text-right">{convertNumber(item.discount).intoCurrency}%</td>
              <td className="text-right">{convertNumber(item.total).intoCurrency}</td>
              <td>{item.tax_name} ({item.tax_rate}%)</td>
              <td />
            </tr>
          )
        })}
      </tbody>
    </BaseTable>
  )
}